// Plain links (full page load) so /privacidad and /terminos are served as static HTML (REQ-363/364).
export const LegalFooter = ({ className = "" }) => (
  <footer className={`flex justify-center gap-4 text-xs text-[#8a97ad] ${className}`} data-testid="legal-footer">
    <a href="/privacidad" className="hover:text-white hover:underline" data-testid="footer-privacy-link">Aviso de privacidad</a>
    <span aria-hidden="true">·</span>
    <a href="/terminos" className="hover:text-white hover:underline" data-testid="footer-terms-link">Términos de uso</a>
  </footer>
);
